import React, { FunctionComponent } from "react";
import { useStaticQuery, graphql } from "gatsby";
import {
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableColumnHeaderCell,
    DataTableContent,
    DataTableHeaderRow,
    DataTableRow
} from "@episerver/ui-framework";

interface ComponentPropsType {
    componentName: string;
}

interface ComponentMetaDataPropTypeValue {
    name: string;
}

interface ComponentMetaDataProp {
    description: {
        text: string;
    };
    name: string;
    required: boolean;
    type: {
        name: string;
        value: ComponentMetaDataPropTypeValue[];
    };
}

interface AllComponentMetadataQueryType {
    allComponentMetadata: {
        nodes: {
            displayName: string;
            props: ComponentMetaDataProp[];
        }[];
    };
}

const query = graphql`
    query {
        allComponentMetadata {
            nodes {
                displayName
                props {
                    description {
                        text
                    }
                    name
                    required
                    type {
                        name,
                        value
                    }
                }
            }
        }
    }
`;

const getPropType = (prop: ComponentMetaDataProp): string => {
    if (prop.type.name !== "union") {
        return prop.type.name;
    }

    return prop.type.value
        .map((type: ComponentMetaDataPropTypeValue) => type.name)
        .join(" | ");
};

export const ComponentProps: FunctionComponent<ComponentPropsType> = ({
    componentName
}) => {
    const result = useStaticQuery<AllComponentMetadataQueryType>(query);
    const metadata = result.allComponentMetadata.nodes.find(
        node => node.displayName === componentName
    );

    if (!metadata) {
        return null;
    }

    return (
        <>
            <h4>{componentName}</h4>
            <DataTable header={componentName}>
                <DataTableContent>
                    <DataTableHeaderRow>
                        <DataTableColumnHeaderCell>Prop Name</DataTableColumnHeaderCell>
                        <DataTableColumnHeaderCell>Type</DataTableColumnHeaderCell>
                        <DataTableColumnHeaderCell>Required</DataTableColumnHeaderCell>
                        <DataTableColumnHeaderCell>Description</DataTableColumnHeaderCell>
                    </DataTableHeaderRow>
                    <DataTableBody>
                        {metadata.props.map(prop => (
                            <DataTableRow rowId={prop.name} key={prop.name}>
                                <DataTableCell>{prop.name}</DataTableCell>
                                <DataTableCell>{getPropType(prop)}</DataTableCell>
                                <DataTableCell>{prop.required.toString()}</DataTableCell>
                                <DataTableCell>{prop.description.text}</DataTableCell>
                            </DataTableRow>
                        ))}
                    </DataTableBody>
                </DataTableContent>
            </DataTable>
        </>
    );
};
